import { SofService } from "./SofService";
import { ExecuteAction2, ExecuteActivity } from "../models";
import { ActivityResult } from "../models";
import { LineHandling } from "../models";
import { ExecuteAction1 } from "../models";
import { ActivitiesResult } from "../models";
import { ExecuteActionsResult } from "../models";
import moment from "moment";
import {
  OfflineActivityLog,
  OfflineDataHistory
} from "../models/OfflineDataHistory";
import { PersistentDataService } from "./PersistentDataService";
import { SofProcessor } from "./SofProcessor";
import { Post } from "../api/apiUtils";

export class ActivityService {
  public actionName: string = "";

  public async executeAction(
    executeAction: ExecuteActivity
  ): Promise<ActivityResult> {
    var lineHandling = await PersistentDataService.getLineHandlingAsync(
      executeAction.lineHandlingNo
    );
    var activities = await PersistentDataService.getActivities(
      executeAction.lineHandlingNo
    );
    var actionId = executeAction.processActionId;
    const history = {
      lineHandling,
      activities,
      actionId
    } as OfflineDataHistory;
    this.addhistory(executeAction.lineHandlingNo, history);

    const sofService = new SofService();
    await sofService.initilizeLineHandling(
      executeAction.lineHandlingNo,
      executeAction.nominationNo
    );
    await sofService.initializeAction(
      executeAction.activityId,
      executeAction.processActionId,
      executeAction.surveyor
    );

    this.actionName = await sofService.executeAction(
      moment.utc(executeAction.executionTime).format("L LTS"),
      [] //executeAction.inputValues
    );
    await sofService.triggerActionsAsync();
    await sofService.processNextStepAsync();
    await sofService.moveStateAsync();
    await sofService.modifyActivityAsync();
    await sofService.checkForActiveActivities();
    await sofService.updateProgressAsync();

    return sofService.activityResult;
  }

  public async executeActionAsync(
    action: ExecuteAction1,
    currentUser: string,
    offlineExecute: (() => void) | undefined = undefined
  ): Promise<ActivitiesResult> {
    const response = await Post(
      `api/v1.5/linehandling/${action.lineHandlingNo}/activities/execute`,
      JSON.stringify(action)
    );
    if (response.ok) {
      const result = (await response.json()) as ActivitiesResult;
      return result;
    } else if (response.status === 399) {
      const processor = new SofProcessor(currentUser);
      await processor.initializeNominationAsync(
        action.lineHandlingNo,
        action.nominationNo
      );
      processor.executeAction(action);
      processor.processOtherAction();
      processor.processNextStep();
      processor.modifyData();
      processor.moveState();
      processor.updateProgress();

      const result = await processor.saveChanges();
      console.log("Offline Execute", result);
        if (offlineExecute) offlineExecute();
      return result;
    } else {
      let errorMessage = "Unexpected error occurs. Please try again.";
      try {
        const message = await response.json();
        if (message && message.message) errorMessage = message.message;
      } catch (ex) {}
      throw new Error(errorMessage);
    }
  }

  public async executeNominationActionAsync(
    action: ExecuteAction2,
    currentUser: string,
    offlineExecute: (() => void) | undefined = undefined
  ): Promise<ActivitiesResult> {
    const response = await Post(
      `api/v1/nomination/${action.nominationNo}/activities/execute`,
      JSON.stringify(action)
    );
    if (response.ok) {
      const result = (await response.json()) as ActivitiesResult;
      return result;
    } 
    //for offline mode
    // else if (response.status === 399) {
    //   const processor = new SofProcessor(currentUser);
    //   await processor.initializeNominationAsync(
    //     action.lineHandlingNo,
    //     action.nominationNo
    //   );
    //   processor.executeAction(action);
    //   processor.processOtherAction();
    //   processor.processNextStep();
    //   processor.modifyData();
    //   processor.moveState();
    //   processor.updateProgress();

    //   const result = await processor.saveChanges();
    //   console.log("Offline Execute", result);
    //     if (offlineExecute) offlineExecute();
    //   return result;
    // } 
    else {
      let errorMessage = "Unexpected error occurs. Please try again.";
      try {
        const message = await response.json();
        if (message && message.message) errorMessage = message.message;
      } catch (ex) {}
      throw new Error(errorMessage);
    }
  }

  public async offlineExecuteAsync(
    action: ExecuteAction1,
    currentUser: string,
    offlineExecute?: () => void
  ) {
    const processor = new SofProcessor(currentUser);
    await processor.initializeNominationAsync(
      action.lineHandlingNo,
      action.nominationNo
    );
    processor.executeAction(action);
    processor.processOtherAction();
    processor.processNextStep();
    processor.modifyData();
    processor.moveState();
    processor.updateProgress();

    const result = await processor.saveChanges();
    console.log("Offline Execute", result);
    if (offlineExecute) offlineExecute();
    return result;
  }

  public async executeActionsAsync(
    offlineData: OfflineActivityLog
  ): Promise<ExecuteActionsResult | undefined> {
    const response = await Post(
      `api/v1.5/linehandling/${offlineData.lineHandlingNo}/activities/executemultiple`,
      JSON.stringify(offlineData.actions)
    );
    if (response.ok) {
      const result = (await response.json()) as ExecuteActionsResult;
      return result;
    }

    return undefined;
  }

  // public addOfflineData(executeAction: ExecuteActivity) {
  //   let data = localStorage.getItem("offline-data");
  //   let items: ExecuteActivity[] = [];
  //   if (data) {
  //     items = [...(JSON.parse(data) as ExecuteActivity[]), executeAction];
  //   } else {
  //     items = [executeAction];
  //   }

  //   this.saveOfflineData(items);
  // }

  public removeOfflineData(lineHandlingNo: string): void {
    const data = localStorage.getItem("offline-data");
  }

  public saveOfflineData(executeActions: ExecuteActivity[]) {
    localStorage.removeItem("offline-data");
    localStorage.setItem("offline-data", JSON.stringify(executeActions));
  }

  public getOfflineData(): ExecuteActivity[] {
    const data = localStorage.getItem("offline-data");
    if (data) {
      return JSON.parse(data) as ExecuteActivity[];
    }
    return [];
  }

  public addhistory(
    lineHandlingNo: string,
    offlineData: OfflineDataHistory
  ): void {
    lineHandlingNo = lineHandlingNo.toLowerCase();
    const history = localStorage.getItem(lineHandlingNo);
    if (history) {
      let data = JSON.parse(history) as OfflineDataHistory[];

      if (data) {
        data.push(offlineData);
      } else {
        data = [offlineData];
      }

      localStorage.setItem(lineHandlingNo, JSON.stringify(data));
    } else {
      localStorage.setItem(lineHandlingNo, JSON.stringify([offlineData]));
    }
  }

  public removeFirstInHistory(lineHandlingNo: string) {
    lineHandlingNo = lineHandlingNo.toLowerCase();
    const history = localStorage.getItem(lineHandlingNo);
    if (history) {
      let data = JSON.parse(history) as OfflineDataHistory[];

      var synching = data[0];
      localStorage.setItem("synching", JSON.stringify(synching));

      data = data.slice(1);
      if (data.length > 0)
        localStorage.setItem(lineHandlingNo, JSON.stringify(data));
      else localStorage.removeItem(lineHandlingNo);
    }
  }

  public redoHistory(lineHandlingNo: string) {
    lineHandlingNo = lineHandlingNo.toLowerCase();
    const history = localStorage.getItem(lineHandlingNo);
    if (history) {
      let data = JSON.parse(history) as OfflineDataHistory[];
      const synching = localStorage.getItem("synching");

      if (synching) {
        const firstData = JSON.parse(synching) as OfflineDataHistory;
        data = [firstData, ...data];
        localStorage.setItem(lineHandlingNo, JSON.stringify(data));
      }
    }
  }

  public synchSuccess() {
    localStorage.removeItem("synching");
  }

  public async updateNomination(
    lineHandlingNo: string,
    nominationNo: string,
    shipLine: string | undefined,
    shipVaporLine: string | undefined,
    vaporLine: string | undefined,
    stowage: string | undefined
  ): Promise<LineHandling | null> {
    var lineHandling = await PersistentDataService.getLineHandlingAsync(
      lineHandlingNo
    );
    if (lineHandling) {
      var nom = lineHandling.nominations.find(
        f => f.nominationNo.toLowerCase() === nominationNo.toLowerCase()
      );

      if (nom) {
        var activities = await PersistentDataService.getActivities(
          lineHandlingNo
        );

        this.addhistory(lineHandlingNo, {
          activities: activities ? activities : [],
          lineHandling,
          actionId: 0
        });

        nom.shipLine = shipLine;
        nom.shipVaporLine = shipVaporLine;
        nom.vaporLine = vaporLine;
        nom.stowage = stowage;

        const result = await PersistentDataService.updateNomination(
          lineHandling,
          nom
        );

        return result;
      }
    }
    return null;
  }

  public async undoAsync(
    lineHandlingNo: string
  ): Promise<OfflineDataHistory | null> {
    lineHandlingNo = lineHandlingNo.toLowerCase();
    const history = localStorage.getItem(lineHandlingNo);
    if (history) {
      let data = JSON.parse(history) as OfflineDataHistory[];

      if (data.length > 0) {
        const lastItemsIndex = data.length - 1;
        const result = data[lastItemsIndex];

        await PersistentDataService.saveLineHandling(result.lineHandling);
        await PersistentDataService.saveActivities(
          lineHandlingNo,
          result.activities
        );

        data = data.slice(0, lastItemsIndex);
        if (data.length > 0)
          localStorage.setItem(lineHandlingNo, JSON.stringify(data));
        else localStorage.removeItem(lineHandlingNo);

        return result;
      }
    }

    return null;
  }
}
